export default __webpack_public_path__ + "static/media/Panorama1.831961cd.jpeg";